const styles = {
    toggle: {
        marginBottom: '10px'
    }
};

export default styles;



// WEBPACK FOOTER //
// src/components/common/CommentSetting/CommentSetting.css.js